// node modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';

// assets
import CssSearchResultsAddNewItem from './AddNewItem.scss';

class SearchResultsAddNewItem extends PureComponent {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    onClick: PropTypes.func,
  };

  static defaultProps = {
    children: null,
    onClick: () => {},
  };

  render() {
    const { children } = this.props;

    return (
      <div className="search-results-matrix__item">
        <button className="add-new-item" onClick={this.props.onClick}>
          <div className="add-new-item__wrapper">
            <div className="add-new-item__body">{children}</div>
          </div>
        </button>
      </div>
    );
  }
}

export default withStyles(CssSearchResultsAddNewItem)(SearchResultsAddNewItem);
